export default __webpack_public_path__ + "static/media/OPAmpsImg.053c6026.jpg";